import LazyLoad from "react-lazyload";


const video = (data) => {
  return (
    data.video && (
      <div className="card-video">
        <LazyLoad>
          <iframe
            width="100%"
            height={200}
            src={data.video}
            title="Bitcoin Bottom Price Prediction | BTC $ 21500"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="video"
          ></iframe>
        </LazyLoad>
      </div>
    )
  );
};

const MasonaryCard = ({ data }) => {
  return (
    <div className="MasonaryCard">
      {video(data)}
      {data.name && (
        <div className="card-desc">
          <div className="card-head">
            {data.linkedin && (
              <div>
                <a href={data.linkedin}>
                  <img className="linkedin-icon" src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1oylj9s.png" />
                </a>
              </div>
            )}
          </div>
          {data.name && <div className="name">{data.name}</div>}
          {data.position && <div className="position">{data.position}</div>}
          {data.about && (
            <div
              className="about"
              dangerouslySetInnerHTML={{ __html: data.about }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MasonaryCard;
